import {useState} from "react";

export default function VideoContainer() {

    const [tabIndex, setTabIndex] = useState(0);

    const Tab = ({ children, index}) => {
      return (
        <div
          className={`flex justify-center items-center w-[130px] h-[40px] lg:w-[250px] lg:h-[80px] rounded-t-[5px] cursor-pointer border-t-2 border-x-2 border-orange-500 font-bold text-body2 lg:text-title2  
            ${index === tabIndex ? 'bg-orange-500 text-white' : 'bg-white text-orange-500'} `}
          onClick={() => setTabIndex(index)}
        >
          {children}
        </div>
      )
    }

    return (
        <div className='w-full wrapper top-space'>
            <div className='flex flex-row gap-x-[5px] pl-[10px] pt-[10px] '>
              <Tab index={0}>링콜 소개 영상</Tab>
              <Tab index={1}>링콜 기능 시연 영상</Tab>
            </div>

            <div className="w-full aspect-[16/9] border-t-2 border-orange-500">
                <iframe
                    width="100%"
                    height="100%"
                    src={`https://www.youtube.com/embed/${tabIndex === 0 ? "znF9DIDC05w?si=ucNBxwSHRMyaPLIA" : "ED5O_GEwP1I?si=Ou1KW8EeO0xbNz2S"}`}
                    title="YouTube video player"
                    frameBorder="0"
                    allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share; fullscreen"
                    referrerPolicy="strict-origin-when-cross-origin"
                    allowFullScreen
                >
                </iframe>
            </div>
        </div>
    )
}
